module.exports = __webpack_public_path__ + "static/media/Cart.33e095a7.svg";